import {Repository, createRepository} from '@/repositories/Base/Repository'

class LoincRepository extends Repository {
    endpoint = 'loinc/exams'

    fetch(loinc) {
        return this.$axios.get(`${this.endpoint}/${loinc}/show`)
    }

    put(params) {
        return this.$axios.put(`${this.endpoint}`, params)
    }

    fetchSynonyms(loinc) {
        return this.$axios.get(`${this.endpoint}/${loinc}/synonyms`)
    }

    fetchLangs(loinc) {
        return this.$axios.get(`${this.endpoint}_langs/${loinc}/show`)
    }

    fetchStatusOptions(params) {
        return this.$axios.get(`${this.endpoint}/status_options`, {params})
    }

    fetchOrderObsOptions(params) {
        return this.$axios.get(`${this.endpoint}/order_observation_options`, {params})
    }
}

export default new LoincRepository()

export const create = createRepository(LoincRepository)
